<template>
  <v-container fluid :class="!showFilters ? 'py-0' : ''" @click="$emit('closeList')">
    <v-row id="sticky-wrapper">
      <v-col
        :lg="showFilters ? 6 : 12"
        id="AutoCompleteSearchBox"
        class="pt-0"
        :cols="!isSticky && showFilters ? 11 : 12"
      >
        <v-row v-if="showFilters" class="sticky-hide">
          <p class="black--text text-right search-title-sticky display-22 pr-4 mb-0 mt-sm-0 mt-3">
            {{ isNoCvPage ? SearchParams.Constants.SearchTitleNoCv : SearchParams.Constants.SearchTitle }}
          </p>
        </v-row>
        <AutoComplete
          id="AutoCompleteSearch"
          search-input-wrap-class="resultsMain_search_search-input-wrap pt-0"
          class="resultsMain_search-wrap"
          :employment="employment"
          :search-properties="searchProperties"
          :placeholder="SearchParams.Constants.WhatPlaceHolder"
          :geoLexPlaceholder="SearchParams.Constants.WherePlaceHolder"
          @autocompleteSearch="autocompleteSearch"
          :isSticky="isSticky"
          :isIndex="isIndex"
        />
      </v-col>
      <v-col v-if="showFilters" cols="12" lg="6" class="pt-0" id="filters">
        <v-row class="px-0 px-md-3 px-lg-0 sticky-hide">
          <v-col cols="8" class="py-0">
            <p class="black--text text-right display-22 mb-0 pb-1">
              {{ isNoCvPage ? SearchParams.Constants.FilteringOptionsNoCv :SearchParams.Constants.FilteringOptions }}
            </p>
          </v-col>
        </v-row>
        <v-row
          justify="space-between"
          class="flex-nowrap search-filter-wrapper"
        >
          <v-col class="pa-0">
            <CategoryFilter
              :filterData="filters.FilterByCategory"
              :data-cy="'cy-button-cat-filters'"
              :selectedOptions="
                searchProperties && searchProperties.catdir
                  ? [...searchProperties.catdir]
                  : []
              "
              :filterDisabled="
                filters.FilterByCategory.Options && filters.FilterByCategory.Options.length ? false : true
              "            
              :defaultTitle="SearchParams.FilterTitle.Category"
              @submitFilter="applyFilter"
            />
          </v-col>
          <v-col class="pa-0">
            <SimpleFilter
              :filterData="filters.FilterBySubCategory"
              :data-cy="'cy-button-subcat-filter'"
              :selectedOptions="searchProperties ? searchProperties.subcat : []"
              :filterDisabled="
                filters.FilterBySubCategory.Options && filters.FilterBySubCategory.Options.length ? false : true
              "   
              :defaultTitle="SearchParams.FilterTitle.SubCategory"
              @submitFilter="applyFilter"
            />
          </v-col>    
          <v-col :class="{ 'hide-cv-filter': isNoCvPage }" class="pa-0">
            <CvFilter 
              @submitFilter="applyFilter"
              :filterData="filters.FilterByCv && filters.FilterByCv.Options.length ?  filters.FilterByCv : t('titles.cvFilterData')"
              :selectedCv="searchProperties ? searchProperties.CV : []"
              :defaultTitle="''"
              :filterDisabled="
                filters.FilterByCategory.Options && filters.FilterByCategory.Options.length ? false : true
              "  
            />
          </v-col>
          <v-col class="pa-0">
            <SimpleFilter
              :filterData="filters.FilterByExperience"
              :data-cy="'cy-button-experience-filter'"
              :selectedOptions="
                searchProperties ? searchProperties.experience : []
              "
              :filterDisabled="
                filters.FilterByExperience.Options && filters.FilterByExperience.Options.length ? false : true
              "            
              :defaultTitle="SearchParams.FilterTitle.Experience"
              @submitFilter="applyFilter"
            />
          </v-col>
          <v-col class="pa-0">
            <SimpleFilter
              :filterData="filters.FilterByScope"
              :data-cy="'cy-button-scope-filter'"
              :filterDisabled="
                filters.FilterByScope.Options && filters.FilterByScope.Options.length ? false : true
              "          
              :selectedOptions="searchProperties ? searchProperties.scope : []"
              :defaultTitle="SearchParams.FilterTitle.Scope"
              @submitFilter="applyFilter"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AutoComplete from '@/components/HomePageComponents/AutoComplete/AutoComplete';
import CategoryFilter from '@/components/JobsSearch/CategoryFilter';
import SimpleFilter from '@/components/JobsSearch/SimpleFilter';
import CvFilter from '@/components/JobsSearch/CvFilter';
import { t } from '@/store/modules/homeDrushim/constantsContent';
import SearchParams from '@/lib/enums/SearchParams';
import { addUrlPart, addQueryParameter } from '@/lib/urlUtils';

export default {
  components: {
    AutoComplete,
    CategoryFilter,
    SimpleFilter,
    CvFilter
  },
  data() {
    return {
      SearchParams: SearchParams,
      isFilterSearch: true,
      isFreeSearch: false,
      selectedCategory: undefined,
      selectedSubCategory: undefined,
      selectedExperience: undefined,
      selectedScope: undefined,
      selectedAreas: undefined,
      selectedCv: undefined,
      whatField: undefined,
      whereField: undefined,
      isCorona: false,
      isJD: false,
      isCompanySearch: false,
      srcBar: false,
      stsCategory: undefined,
      classifiedParams: {
        // params to pass to server without displaying in url
        geolexid: undefined,
        range: undefined,
        ssaen: SearchParams.ssaen.RegularSearch,
      },
    };
  },
  props: {
    isNoCvPage: {
      type: Boolean,
      required: false,
      default: false
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    isSticky: {
      type: Boolean,
      required: false,
      default: false,
    },
    isIndex: {
      type: Boolean,
      required: false,
      default: true,
    },
    showFilters: {
      type: Boolean,
      required: false,
      default: false,
    },
    filters: {
      type: Object,
      required: false,
      default() {
        return {
          FilterByCategory: {},
          FilterBySubCategory: {},
          FilterByZones: {},
          FilterByExperience: {},
          FilterByScope: {},
          FilterByCv: t('titles.cvFilterData')
        };
      },
    },
    searchProperties: {
      type: Object,
      required: false,
      default: undefined,
    },
    employment: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  mounted() {
    this.initDataMembers();
  },
  beforeDestroy() {},

  methods: {
    autocompleteSearch(payload) {
      this.isFreeSearch = payload.isFreeSearch;
      this.isJD = payload.isJD;
      this.isCompanySearch = payload.isCompanySearch;

      if (this.isFreeSearch) {
        this.whatField = payload.searchterm;
        this.selectedCategory = undefined;
        this.selectedSubCategory = undefined;
      } else if (payload.searchterm) {
        if (payload.searchterm.type === SearchParams.STS.SearchBySubCategory) {
          const subcat =
            payload.searchterm[SearchParams.STS.SearchTypeIdentifier];
          this.selectedSubCategory = [].concat(parseInt(subcat));
          this.whatField = undefined;
          this.selectedCategory = undefined;
        } else if (this.isJD) {
          this.whatField = payload.jdTerm;
          this.selectedCategory = undefined;
          this.selectedSubCategory = undefined;
        } else if (this.isCompanySearch) {
          this.whatField = payload.searchterm.displayString;
          this.selectedCategory = undefined;
          this.selectedSubCategory = undefined;
        } else {
          this.selectedCategory =
            payload.searchterm[SearchParams.STS.SearchTypeIdentifier];
          this.whatField = undefined;
          this.selectedSubCategory = undefined;
        }
      } else {
        //remove what
        this.whatField = undefined;
        this.selectedCategory = undefined;
        this.selectedSubCategory = undefined;
      }

      if (
        payload.location &&
        payload.location.displayString &&
        payload.location.typeRelativeId
      ) {
        this.whereField = payload.location.displayString;
        this.classifiedParams.geolexid = [].concat(
          payload.location.typeRelativeId
        );
        this.classifiedParams.range = payload.distance.Code;
        this.selectedAreas = payload.location.drushim_region_ids.split(
          SearchParams.STS.RegionSeparator
        );
      } else {
        // remove where properties
        this.whereField = undefined;
        this.classifiedParams.geolexid = [];
        this.classifiedParams.range = undefined;
      }

      this.classifiedParams.ssaen = SearchParams.ssaen.RegularSearch;
      this.isFilterSearch = false;
      this.search();
    },

    applyFilter(filter) {
      switch (filter.type.toLowerCase()) {
        case SearchParams.QueryParams.Category:
          this.selectedCategory = undefined; //you can only clear category
          this.selectedSubCategory = undefined;
          break;
        case SearchParams.UrlPart.SubCategory:
          this.selectedSubCategory = filter.selections;
          break;
        case SearchParams.QueryParams.Experience:
          this.selectedExperience = filter.selections;
          break;
        case SearchParams.QueryParams.Scope:
          this.selectedScope = filter.selections;
          break;
        case SearchParams.QueryParams.Area:
          if (filter.selectedRegions && filter.selectedRegions.size > 0) {
            this.selectedAreas = Array.from(filter.selectedRegions);
            this.classifiedParams.geolexid = Array.from(filter.selectedGeolex);
          } else {
            this.selectedAreas = undefined;
            this.classifiedParams.geolexid = [];
            this.classifiedParams.range = undefined;
          }
          break;
          case SearchParams.QueryParams.Cv:
            this.selectedCv = filter.selections;
          break;
      }

      this.classifiedParams.ssaen = SearchParams.ssaen.FilterSearch;
      this.isFilterSearch = true;
      this.search();
    },

    search() {
      const requestUrl = this.searchRequestBuilder;
      if (requestUrl === '/') {
        this.$nuxt.$loading.start();
      }
      if (this.$route.fullPath.toLowerCase() !== requestUrl.toLowerCase()) {
        this.$router.push(requestUrl);
      }
    },

    initDataMembers() {
      if (this.searchProperties) {
        this.whatField = this.searchProperties.WhatFieldText;
        this.whereField = this.searchProperties.WhereFieldText;
        this.classifiedParams.range = this.searchProperties.Range?.Code;
        this.classifiedParams.geolexid = [].concat(
          this.searchProperties.WhereFieldGeoLex
            ? this.searchProperties.WhereFieldGeoLex
            : []
        );
        this.classifiedParams.ssaen = this.searchProperties.ssaen;
        this.selectedExperience = this.searchProperties.experience;
        this.selectedScope = this.searchProperties.scope;
        this.selectedCategory = this.searchProperties.catdir;
        this.selectedSubCategory = this.searchProperties.subcat;
        this.selectedAreas = this.searchProperties.AreasList;
        this.isFreeSearch = this.searchProperties.IsSearchTerm;
        this.stsCategory = this.searchProperties.stsCategory;
        this.selectedCv = this.searchProperties.CV;
      }
    },
  },
  computed: {
    getCurrenBasetUrl() {
      return this.$route.fullPath.includes(SearchParams.Constants.DefaultBaseUrlNoCv) ? 
      SearchParams.Constants.DefaultBaseUrlNoCv : SearchParams.Constants.DefaultBaseUrl;
    },
    searchRequestBuilder() {
      let baseUrl = this.getCurrenBasetUrl;
      
      let queryString = '';

      if (this.selectedSubCategory && this.selectedSubCategory.length > 0) {
        baseUrl = addUrlPart(
          baseUrl,
          SearchParams.UrlPart.SubCategory,
          getParamValue(this.selectedSubCategory)
        );
      } else if (this.selectedCategory) {
        baseUrl = addUrlPart(
          baseUrl,
          SearchParams.UrlPart.Category + this.selectedCategory
        );
      }

      if (
        !!this.whereField &&
        !!this.classifiedParams.geolexid &&
        !this.isFilterSearch
      ) {
        if (this.selectedAreas && this.selectedAreas.length > 0) {
          baseUrl = addUrlPart(
            baseUrl,
            SearchParams.UrlPart.Area,
            getParamValue(this.selectedAreas)
          );
        }
      }
      
      if (this.isFilterSearch) {
        
        if (this.selectedAreas && this.selectedAreas.length > 0) {
          baseUrl = addUrlPart(
            baseUrl,
            SearchParams.UrlPart.Area,
            getParamValue(this.selectedAreas)
          );
        }

        if (this.selectedExperience && this.selectedExperience.length > 0) {
          queryString = addQueryParameter(
            queryString,
            SearchParams.QueryParams.Experience,
            getParamValue(this.selectedExperience)
          );
        }
        if (this.selectedCv?.length) {
          queryString = addQueryParameter(
            queryString,
            SearchParams.QueryParams.Cv,
            getParamValue(this.selectedCv)
          );
        }

        if (this.selectedScope && this.selectedScope.length > 0) {
          queryString = addQueryParameter(
            queryString,
            SearchParams.QueryParams.Scope,
            getParamValue(this.selectedScope)
          );
        }
      }

      if ((this.isFreeSearch || this.isJD) && this.whatField) {
        if (SearchParams.Constants.DefaultBaseUrl == baseUrl) {
          baseUrl = addUrlPart(
            baseUrl,
            SearchParams.UrlPart.What,
            this.whatField
          );
          // check if on no cv page 
        } else if (SearchParams.Constants.DefaultBaseUrlNoCv == baseUrl) {
          baseUrl = addUrlPart(
            baseUrl,
            SearchParams.UrlPart.What,
            this.whatField
          );

          //check if no filter is triggered
          if (!this.isFilterSearch) {
            queryString += addQueryParameter('?', 'cv', 1);
          }
        } 
        else {
          queryString = addQueryParameter(
            queryString,
            SearchParams.QueryParams.FreeSearch,
            this.whatField
          );
        }
      }
      if (this.isCompanySearch && this.whatField) {
        if (SearchParams.Constants.DefaultBaseUrl == baseUrl) {
          baseUrl = addUrlPart(
            baseUrl,
            SearchParams.UrlPart.What,
            this.whatField
          );
        } else if (SearchParams.Constants.DefaultBaseUrlNoCv == baseUrl) {
          baseUrl = addUrlPart(
            baseUrl,
            SearchParams.UrlPart.What,
            this.whatField
          );

          //check if no filter is triggered
          if (!this.isFilterSearch) {
            queryString += addQueryParameter('?', 'cv', 1);
          }
        } else {
          queryString = addQueryParameter(
            queryString,
            SearchParams.QueryParams.FreeSearch,
            this.whatField
          );
        }
      }

      if (this.addLocationParams) {
        queryString = addQueryParameter(
          queryString,
          SearchParams.QueryParams.Geolexid,
          getParamValue(this.classifiedParams.geolexid)
        );

        if (this.classifiedParams.range && !!this.whereField) {
          // check if on no cv page and no filter is triggered
          if (baseUrl.includes(SearchParams.Constants.DefaultBaseUrlNoCv) && !this.isFilterSearch) {
            queryString += addQueryParameter('&', 'cv', 1).replace('?', '');
          }
          queryString = addQueryParameter(
            queryString,
            SearchParams.QueryParams.Range,
            this.classifiedParams.range
          );
        }
      }
      if (baseUrl + queryString !== SearchParams.Constants.DefaultBaseUrl) {
        queryString = addQueryParameter(
          queryString,
          SearchParams.QueryParams.Ssaen,
          this.classifiedParams.ssaen
        );
      }

      if (
        !baseUrl.includes('/' + SearchParams.UrlPart.Category) &&
        this.stsCategory &&
        this.selectedCategory
      ) {
        queryString = addQueryParameter(
          queryString,
          SearchParams.QueryParams.Category,
          this.stsCategory
        );
      }
      const parsedUrl = baseUrl + queryString;

      return parsedUrl === SearchParams.Constants.DefaultBaseUrl
        ? '/'
        : parsedUrl;
    },
    addLocationParams() {
      return (
        this.classifiedParams.geolexid &&
        this.classifiedParams.geolexid.length > 0
      );
    },
  },
  watch: {
    searchProperties: function () {
      this.initDataMembers();
    },
  },
};

function getParamValue(collection) {
  const values = collection.filter((a) => parseInt(a)).map((a) => parseInt(a));
  const distinct = [...new Set(values)];
  const sorted = distinct.sort((a, b) => a - b);

  return sorted.join(SearchParams.Constants.MultipleSeparator);
}
</script>

<style scoped>
.search-title-sticky {
  white-space: nowrap;
}
.norm-layout .container {
  display: flex !important;
  padding: 0;
}
.sticky-layout .container {
  display: flex !important;
  padding: 0;
}
.jobs-board-content #sticky-wrapper {
  max-width: 1260px;
  margin: 0 auto;
}
.hide-cv-filter {
  display: none;
}
@media screen and (max-width: 1260px) {
  .norm-layout .container {
    display: flex !important;
    flex-direction: column;
    padding: 0;
  }
  .sticky-layout .container {
    display: flex !important;
    flex-direction: column;
    padding: 0;
  }
}
@media screen and (max-width: 600px) {
  ::-webkit-scrollbar {
    display: none;
  }
  .jobs-board-content #sticky-wrapper {
    margin: initial;
  }
  .sticky-layout .sticky-hide {
    display: none;
  }
  .norm-layout .search-filter-wrapper {
    align-items: flex-start;
    overflow: auto;
  }
  .norm-layout .container {
    display: flex !important;
    flex-direction: column;
    padding: 0;
  }
  .sticky-layout .container {
    display: flex !important;
    flex-direction: row;
    padding: 0;
  }
  .sticky-layout #SearchManager #sticky-wrapper {
    flex-wrap: nowrap;
  }
  .sticky-layout #filters {
    padding-bottom: 0;
  }
  .sticky-layout
    #AutoCompleteSearchBox
    #AutoCompleteSearch
    #search-input-wrpper {
    flex-direction: row;
    flex-wrap: nowrap;
  }
}
</style>
